/*
 * File: \apis.js
 * File Created: 2022-04-08 00:35:17
 * Author: Li Haifeng
 * -----
 * Last Modified: 2022-06-21 16:21:44
 * Modified By: lihf14
 */
export default [
  "getUser",
  "isLogin",
  "getUserPassword",
  "toLogin",
  "login",
  "savePw",
  "orgMuChoose",
  "vcard",
  "getContact",
  "logout",
  "authPassword",
  "getH5Info",
  "saveH5Info",
  "getMessageUnread",
  "getExtra",
  "showSetView",
  "showMyView",
  "showAppView",
  "startApp",
  "showWidget",
  "selectWidget",
  "exit",
  "openSysBrowser",
  "openUrl",
  "gotoSystemSetting",
  "openServiceNo",
  "language",
  "showNav",
  "hideNav",
  "showMenu",
  "showInput",
  "hideInput",
  "toggleInput",
  "showFloat",
  "hideFloat",
  "statusBarColor",
  "copy",
  "paste",
  "apk",
  "callPhone",
  "webview",
  "getBase64s",
  "onEvent",
  "setBounces",
  "videoRecord",
  "saveToGallery",
  "getPicture",
  "updateTabUnread",
  "orientation",
  "shake",
  "shakeStop",
  "showShare",
  "chatMessage",
  "chat",
  "isDarkTheme",
  "navigationRightButtons",
  "statusBarColor4Android",
  "getScanExtra",
  "buildQRcodeImage",
  "scan",
  "startUpdatingLocation",
  "stopUpdatingLocation",
  "location",
  "getPois",
  "navTo",
  "navToWithFrom",
  "showPdf",
  "orgSelector",
  "requestLocation"
];